import { useTranslate } from "@refinedev/core";
import { RecordsIcon, SettingsTileCard } from "@fawkes/ui";

import { useModuleAvailability } from "../../../api/modules";
import type { TileComponentProps } from "./types";

// Taken — automatic task rules, deadline rules and task packages. Shown in BOTH contexts (Jmix
// SettingsDashboardView: branch "Algemeen" + org "Dieren"), module-gated on `taken`. Δ2 Phase 2
// (Slice B3): the api REST surface (GET/POST /api/taken-config) + the in-SPA builder are built, so
// "Openen" opens the migrated detail in-place (TakenRulesSettings) instead of handing off to the Jmix
// view — the additive strangler step (the Jmix /taken-instellingen view stays reachable but unused).
export const TAKEN_TILE_KEY = "taken";

const ITEM_KEYS = ["instellingen.item.automatischeTaken"];

export function TakenTile({ onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  const { isModuleEnabled } = useModuleAvailability();
  if (!isModuleEnabled("taken")) return null;
  return (
    <SettingsTileCard
      tileKey={TAKEN_TILE_KEY}
      icon={<RecordsIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.taken.title")}
      description={t("instellingen.tile.taken.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("taken")}
    />
  );
}
